import { Directive, OnDestroy, ViewContainerRef } from '@angular/core';

@Directive({
  selector: '[miqWizardProjector]',
  standalone: false,
})
export class WizardProjectorDirective implements OnDestroy {
  constructor(public viewContainerRef: ViewContainerRef) {}
  ngOnDestroy(): void {
    if (this.viewContainerRef) {
      this.viewContainerRef.clear();
      this.viewContainerRef = null;
    }
  }
}
